module Meevo.Components.Common {
    type TPromiseFn = () => ng.IPromise<any>;

    export class PromiseChain {

        private _deferred: angular.IDeferred<any>;
        private _list: TPromiseFn[] = [];

        constructor(private _$q: angular.IQService) {
            this._deferred = _$q.defer();
        }

        push(p: TPromiseFn) {
            this._list.push(p);
        }

        then(_resolve: (...args: any[]) => any, _reject?: (error: any) => void, _finally?: () => any) {
            !_reject && (_reject = (error) => console.error(error));
            !_finally && (_finally = () => {
            });

            return this._list.reduce(
                (previousPromise, nextPromise: TPromiseFn) => {
                    return previousPromise.then(nextPromise);
                },
                this._$q.resolve()
            )
                .then(() => _resolve())
                .catch(error => _reject(error))
                .finally(() => _finally());
        }
    }


    export function toQPromise<T>($q: ng.IQService, promise: () => Promise<T>): ng.IPromise<T> {
        return new $q((resolve, reject) => {
           promise().then(resolve).catch(reject);
        });
    }

    export class MeevoMap<T> {
        readonly result: _.Dictionary<T[]>;

        constructor() {
          this.result  =  {};
        }

        add(key: string, data: T) {
          if (!this.result[key]) this.result[key] = [];

          this.result[key].push(data);
        }

        get(key: string) {
          return this.result[key];
        }
    }

    export class Utilities {
        // Uses url OR rawData. If url is supplied it will build the link to download directly from there
        // If url is null and rawData is supplied, it will build an object URL to download using the pre-existing raw data
        public static downloadFile(url: string, rawData: string, filename: string): void {
            const link = document.createElement("a");
            if (link["download"] !== undefined) {
                if (!url && rawData) {
                    const blob = new Blob([rawData]);
                    url = url = URL.createObjectURL(blob);
                }
                link.setAttribute("href", url);
                link.setAttribute("download", filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }

        public static defaultIfNothing<T>(value: T, defaultValue: T): T {
            return angular.isUndefined(value) ? defaultValue : value;
        }
    }
}
